import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Directive({
  selector: '[asyncClick]'
})
export class AsyncClickDirective implements OnInit, OnChanges {
  @HostBinding('attr.disabled') attrDisabed: boolean;
  @HostBinding('class.btn--striped') striped: boolean = false;

  @Input()
  disabled: boolean;

  @Output()
  asyncClick: EventEmitter<any> = new EventEmitter<any>();

  @HostListener('click')
  async onClick() {
    this.processing(true);
    const next = () => this.processing(false);
    this.asyncClick.emit(next);
  }

  constructor() {
  }

  ngOnInit() {
    this.attrDisabed = this.disabled;
  }

  ngOnChanges({ disabled }: SimpleChanges) {
    this.attrDisabed = this.disabled || null;
  }

  processing(isProcessing: boolean) {
    this.attrDisabed = isProcessing || null;
    this.striped = isProcessing;
  }
}
